<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>指挥中心</el-breadcrumb-item>
			<el-breadcrumb-item>质量信息统计</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="form-bar">
			<el-form :inline="true">
				<el-form-item label="时间范围">
					<DateRange v-model="dateRange" />
				</el-form-item>
				<el-form-item label="车间选择" v-if="!userWorkshopId">
					<el-select placeholder="车间选择" v-model="workshop" :clearable="true">
						<el-option :label="item.label" :value="item.value" v-for="item in workshops" :key="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="机台选择">
					<el-select placeholder="机台选择" v-model="jt_id" :clearable="true">
						<el-option :label="item.label" :value="item.value" v-for="item in jt_list" :key="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="info" v-on:click="search">批次查询</el-button>
				</el-form-item>
			</el-form>
		</div>

		<el-table border :data="tableData" v-loading="tableLoading" row-key="id" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
			<el-table-column width="30"></el-table-column>
			<el-table-column prop="index" width="60" label="序号"></el-table-column>
			<el-table-column prop="productName" label="产品名称"></el-table-column>
			<el-table-column prop="jtName" label="机台" width="150"></el-table-column>
			<el-table-column prop="workCode" label="工单号" width="100"></el-table-column>
			<el-table-column prop="batchCode" label="批次号" width="150"></el-table-column>
			<el-table-column prop="batchStatus" label="批次状态" width="120"></el-table-column>
			<el-table-column prop="filterStatus" label="筛选状态" width="80"></el-table-column>
			<el-table-column prop="inspCount" label="检测张数" width="100"></el-table-column>
			<el-table-column prop="badCount" label="坏品张数" width="100"></el-table-column>
			<el-table-column prop="totalLength" label="总长度" width="100"></el-table-column>
			<el-table-column prop="totalDefCount" label="缺陷个数" width="80"></el-table-column>
			<el-table-column prop="totalBadCount" label="坏品个数" width="80"></el-table-column>
			<el-table-column label="缺陷统计" width="120" fixed="right">
				<template slot-scope="scope">
					<el-button type="text" icon="el-icon-s-data" @click="handleViewStat(scope.row)" :disabled="scope.row.inspCount == 0">查看</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--分页-->
		<el-pagination layout="sizes, prev, pager, next, total" :page-count="pageCount" :page-sizes="[10, 50, 100, 200]" :size="pageSize" @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
	</div>
</template>

<script>
	import DateRange from '@/components/DateRangePicker'
	import defectService from '@/service/defectService'
	import dictionaryData from '@/service/dictionaryData'
	import jobOrderService from '@/service/jobOrderService'
	import { mapGetters } from 'vuex'
	import { workshopRequest } from '@/network/requests/workshop'
	export default {
		components: {
			DateRange,
		},
		data() {
			return {
				workshop: '',
				workshops: [],
				jt_id: '',
				jt_list: [],
				jt_data: [],
				dateRange: [],
				tableData: [],
				tableLoading: false,
				pageCount: 1,
				pageSize: 10,
				pageIndex: 1,
			}
		},
		computed: {
			...mapGetters(['userWorkshopId']),
		},
		watch: {
			/**
			 * 选择车间。
			 */
			workshop(val) {
				this.jt_list = this.jt_data.filter(t => t.workshop == val)
				if (this.jt_list.length > 0) {
					this.jt_id = this.jt_list[0].value
				} else {
					this.jt_id = ''
				}
			},
		},
		methods: {
			/**
			 * 查询批次信息。
			 */
			search() {
				this.pageIndex = 1
				this.tableLoading = true
				this.query()
			},
			/**
			 * 获取查询条件。
			 */
			getFilter() {
				var filter = {}
				if (this.dateRange) {
					if (this.dateRange.length > 0) {
						filter.begin_time = {
							$gte: { $date: new Date(this.dateRange[0]).getTime() },
							$lte: { $date: new Date(this.dateRange[1]).getTime() },
						}
					}
				}

				if (this.jt_id) {
					filter.jt_id = this.jt_id
				} else if (this.workshop) {
					var jt_id_array = this.jt_list.map(t => t.value)
					filter.jt_id = { $in: jt_id_array }
				}

				return filter
			},
			/**
			 * 查询。
			 */
			query() {
				var filter = this.getFilter()
				jobOrderService.getJobOrderDefectStatisAsync(this.pageIndex, this.pageSize, filter).then(res => {
					this.tableData = res.data
					this.pageCount = res.totalPage
					this.tableLoading = false
				})
			},
			/**
			 * 切换页码。
			 */
			handleCurrentChange(page) {
				this.tableLoading = true
				this.pageIndex = page
				this.query()
			},
			/**
			 * 修改每页记录数量。
			 */
			handleSizeChange(size) {
				this.tableLoading = true
				this.pageIndex = 1
				this.pageSize = size
				this.query()
			},
			/**
			 * 查看缺陷统计。
			 */
			handleViewStat(row) {
				console.log('查看缺陷统计', row)
				const routeData = this.$router.resolve({ name: 'ControlMonitorDefectStatisticalView', query: { defect_statis_id: row.id, type: row.target } })
				window.open(routeData.href, '_blank')
			},
			indexMethod() {
				return ''
			},
		},
		async created() {
			this.tableLoading = true

			var jt_filter = undefined

			if (this.userWorkshopId) {
				this.workshop = this.userWorkshopId
				this.workshopInfo = (await workshopRequest.getDocumentById(this.userWorkshopId)).data
				jt_filter = { workshop_id: this.userWorkshopId }
			} else {
				//获取所有车间。
				this.workshops = await dictionaryData.getWorkshops()
			}

			//机台。
			this.jt_data = await dictionaryData.getJTList(jt_filter)
			this.jt_list = this.jt_data

			await this.query()
		},
	}
</script>

<style></style>
